import { INTEGRATION_PARTNER, INTEGRATION_PARTNER_MAP } from './enum';
import { generatePKCEPair } from './pkce';
import AppConfig from '../AppConfig';
import { setLocalStorageItem } from './localStorageUtil';

export const casePeerLogin = async ({ clientId } = {}) => {
  try {
    if (!clientId) {
      throw new Error('Client ID is required for CasePeer OAuth');
    }
    // Store current location to redirect back after auth
    setLocalStorageItem('casepeer_redirect_url', window.location.href);

    const { codeVerifier, codeChallenge } = await generatePKCEPair();

    setLocalStorageItem('casepeer_pkce_code_verifier', codeVerifier);

    const authUrl = new URL(`https://${AppConfig.CasePeerBaseUrl}/o/authorize`);
    
    authUrl.searchParams.append('client_id', clientId);
    authUrl.searchParams.append('redirect_uri', INTEGRATION_PARTNER_MAP[INTEGRATION_PARTNER.CASEPEER].redirectURL);
    authUrl.searchParams.append('response_type', 'code');
    authUrl.searchParams.append('code_challenge', codeChallenge);
    authUrl.searchParams.append('code_challenge_method', 'S256');

    // Optional parameters
    authUrl.searchParams.append('scope', 'read');

    // Redirect user to the authorization server
    window.location.href = authUrl.toString();
  } catch (error) {
    console.error('Error initiating CasePeer Auth flow:', error);
    throw error; // Rethrow to allow caller to handle the error
  }
};